
import { defineComponent, computed, ref, SetupContext } from 'vue';
import TLogo from './../t-logo/index';

export default defineComponent({
  name: 'TCopyright',
  components: { TLogo },
  props: {
    copyright: { type: String, default: '' },
    introduction: { type: String, default: '' },
    isIntroduction: { type: Boolean, default: false },
    lang: {
      type: String,
      default: 'zh-HK',
      validator: (value: string) => ['en-GB', 'zh-CN', 'zh-HK'].includes(value),
    },
  },
  emits: ['click'],
  setup(props, context: SetupContext) {
    /** 组件的className前辍 */
    const prefixCls = ref('t-copyright');
    /** 组件的className前辍 */
    const getClasses = computed(() => {
      return {
        wrap: [prefixCls.value, props.isIntroduction && `${prefixCls.value}__bg`],
        body: `${prefixCls.value}-bd`,
        description: `${prefixCls.value}-desc`,
        introduction: `${prefixCls.value}-introduction`,
      };
    });
    /** 设置一个map，用于解决版本文案的多语言统一问题 */
    const copyrightMap = {
      'en-GB': 'This service is provided by Fusion Bank',
      'zh-CN': '此服务由Fusion Bank提供',
      'zh-HK': '此服務由Fusion Bank提供',
    };
    const introductionMap = {
      'en-GB':
        "Fusion Bank is a licensed virtual bank in Hong Kong, and a member of Hong Kong's Deposit Protection Scheme with eligible deposits protected to a maximum of HKD 500,000",
      'zh-HK':
        'Fusion Bank 是香港持牌虛擬銀行，亦是香港存款保障計劃成員，所有合資格的存款均受存款保障計劃保障，最高保障額為每名存款人50萬港幣',
      'zh-CN':
        'Fusion Bank 是香港持牌虚拟银行，亦是香港存款保障计划成员，所有合资格的存款均受存款保障计划保障，最高保障额为每名存款人50万港币',
    };
    /** 根据多语言，获取对应的文案信息 */
    const getCopyright = computed(() => {
      const tempLang = props.lang as 'en-GB' | 'zh-CN' | 'zh-HK';
      const output = copyrightMap[tempLang];
      return props.copyright || output;
    });
    const getIntroduction = computed(() => {
      const tempLang = props.lang as 'en-GB' | 'zh-CN' | 'zh-HK';
      const output = introductionMap[tempLang];
      return props.introduction || output;
    });
    /** 对外响应的事件 */
    const listener = (event: any) => context.emit('click', event);

    return { prefixCls, getClasses, getCopyright, getIntroduction, listener };
  },
});
